import React from 'react'
import { Switch, Route, Redirect } from 'react-router-dom'

import { 
  JobsPage,
  JobsNewPage,
  JobPage,
  MachinesPage,
  MachinesNewPage,
  SettingsCompanyPage,
  SettingsJobPresetsPage,
  NotFoundPage,
} from 'components'

import { JobPageDev } from 'components'

const MainContent = () => {
  return (
      <Switch>
        <Route exact path='/jobs' component={JobsPage}/>
        <Route exact path='/jobs/new' component={JobsNewPage}/>
        <Route exact path='/jobs/:id' component={JobPage}/>
        <Route exact path='/jobs/:id/edit' component={JobPage}/>
        <Route exact path='/jobs/:id/export' component={JobPage}/>
        <Route exact path='/machines' component={MachinesPage}/>
        <Route exact path='/machines/new' component={MachinesNewPage}/>
        <Route exact path='/machines/:id' component={MachinesPage}/>
        <Route exact path='/settings/company' component={SettingsCompanyPage}/>
        <Route exact path='/settings/jobpresets' component={SettingsJobPresetsPage}/>
        <Route path="login/support" element={<Redirect to="/" />} />
        <Route path="/" render={() => <Redirect to='/jobs' />}/>
        <Route component={NotFoundPage} />
      </Switch>
  )
}

export default MainContent


// WEBPACK FOOTER //
// ./src/components/MainContent.js